import { DivPaperStyled, ModalStyled, Title } from '../Modals.styled'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import { Backdrop, Fade } from '@mui/material'
import { KTSVG } from '../../../_metronic/helpers'
import { modalStyles } from '../ModalStyles'
import { actionTypes } from '../../modules/auth/redux/PagesRedux'
import { BigSubtitle, Subtitle } from '../Modals/Modals.styled'
import { format } from 'date-fns'

const DateIsWeekendModal = ({open, setOpen, formikValues, dateIsWeekendData}) => {
    const classes = modalStyles({})
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const dispatch = useDispatch()

    return (
        <ModalStyled
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            fontSize={fontSize}
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <DivPaperStyled className={classes.paper}>
                    <div className="row">
                        <div className="d-flex align-items-center justify-content-end">
                            <div className="col-12 d-flex btn btn-icon btn-sm btn-active-light-primary" onClick={() => setOpen(false)}>
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-2x"
                                />
                            </div>
                        </div>
                    </div>
                    <>
                        <div className="row justify-content-center">
                            <div className="col-12 d-flex justify-content-center">
                                <KTSVG path={`/media/icons/bootstrap/exclamation-circle.svg`} className={`svg-icon svg-icon-3x text-warning`}/> 
                            </div>
                            <div className="col-12 d-flex justify-content-center mt-5">
                                <Title style={{margin: 0, fontSize: 15}}>
                                    {dateIsWeekendData?.holidaysAffectingDeliveryDate?.length ? 'Holidays affecting the delivery date' : null}
                                </Title>
                            </div>
                            <div className="col-12 d-flex justify-content-center mt-1 mb-3">
                                <BigSubtitle>
                                    {dateIsWeekendData?.holidaysAffectingDeliveryDate?.map(holiday => {
                                        return (
                                            <p className='mb-2'>- {holiday.name} ({format(new Date(holiday.date.replaceAll('-', '/')), 'MM/dd/yy')})</p>
                                        )
                                    })}
                                </BigSubtitle>
                            </div>
                            <Title style={{margin: 0}}>
                                {dateIsWeekendData?.pickupDateRemarks?.map(dateRemark => {
                                    return (
                                        <div className="col-12 d-flex justify-content-center">
                                            <p className='p-0 mb-1' style={{fontSize: 15}}>{dateRemark}</p>
                                        </div>
                                    )
                                })}
                            </Title>
                            <Title style={{margin: 0}}>
                                {dateIsWeekendData?.deliveryDateRemarks?.map(dateRemark => {
                                    return (
                                        <div className="col-12 d-flex justify-content-center">
                                            <p className='p-0 mb-1' style={{fontSize: 15}}>{dateRemark}</p>
                                        </div>
                                    )
                                })}
                            </Title>
                        </div>
                        <div className="row mt-3 mb-3">
                            <div className="col-12 d-flex justify-content-center">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setOpen(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </>
                </DivPaperStyled>
            </Fade>
        </ModalStyled>
    )
}

export default DateIsWeekendModal